import depsloader from "../depsloader";

let interval = null;

export default {
  namespaced: true,

  state: {
    loginError: false,
    authenticationToken: null,
    internetError: false,
    loggedOut: false,
    hasBeenLoggedIn: false,
    apps: null
  },

  mutations: {
    loginError(state, val) {
      state.loginError = val;
    },

    authenticationToken(state, val) {
      state.authenticationToken = val;
    },

    hasBeenLoggedIn(state, val) {
      state.hasBeenLoggedIn = val;
    },

    internetError(state, val) {
      state.internetError = val;
    },

    loggedOut(state, val) {
      state.loggedOut = val;
    },

    apps(state, apps) {
      state.apps = apps;
    }
  },

  actions: {
    auth({ commit, dispatch }, authenticationToken) {
      commit("authenticationToken", authenticationToken);

      depsloader.load("axios").then((axios) => {
        axios({
          method: "get",
          url: "/wp-json/sw-immoapp/v1/auth/me",
          headers: {
            Authorization: `Bearer ${authenticationToken}`
          }
        }).then((res) => {
          commit("authUser", res.data, { root: true });
          dispatch("appLoaded", true, { root: true });
        }).catch(() => {
          dispatch("appLoaded", true, { root: true });
        });
      });
    },

    logout({ commit, state }) {
      depsloader.load("axios").then((axios) => {
        axios({
          method: "delete",
          url: "/wp-json/sw-immoapp/v1/auth/me",
          headers: {
            Authorization: `Bearer ${state.authenticationToken}`
          }
        }).then(() => {
          commit("loggedOut", true);
          commit("authUser", null, { root: true });
        });
      });
    },

    start({ commit, state }) {
      if (interval) {
        return;
      }

      depsloader.load("axios").then((axios) => {
        interval = window.setInterval(() => {
          axios({
            method: "get",
            url: "/wp-json/sw-immoapp/v1/auth/me",
            headers: {
              Authorization: `Bearer ${state.authenticationToken}`
            }
          }).then(() => {
            // ok
            commit("hasBeenLoggedIn", true);
          }).catch((err) => {
            commit("internetError", false);

            const s = err.toString();
            if (s.indexOf("403") !== -1) {
              if (state.hasBeenLoggedIn) {
                commit("loggedOut", true);
              }
            } else {
              commit("internetError", true);
            }
          });
        }, 60000);
      });
    },

    destroy() {
      if (interval) {
        clearInterval(interval);
      }
    },

    apps({ dispatch, commit }) {
      return new Promise((resolve) => {
        dispatch("ajax", {
          url: "/v1/auth/apps"
        }, { root: true }).then((apps) => {
          resolve();
          commit("apps", apps);
        });
      });
    },
  }
};
